/**
 * Shared lightweight localStorage cache utility for budget/ledger list data.
 * Provides get/set/invalidate with TTL support so multiple components
 * can avoid redundant API calls.
 */

export const BUDGETS_LIST_CACHE_KEY = 'budgetrecon_budgets_list_cache';
export const LEDGERS_LIST_CACHE_KEY = 'budgetrecon_ledgers_list_cache';
export const LIST_CACHE_TTL = 60000; // 60 seconds

/**
 * Returns cached array or null if expired/missing.
 */
export function getCachedList(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const { data, timestamp } = JSON.parse(raw);
    if (Date.now() - timestamp > LIST_CACHE_TTL) {
      localStorage.removeItem(key);
      return null;
    }

    return data;
  } catch {
    return null;
  }
}

/**
 * Stores array with timestamp in localStorage.
 */
export function setCachedList(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify({ data, timestamp: Date.now() }));
  } catch {
    // Silently ignore storage errors (quota exceeded, etc.)
  }
}

/**
 * Removes cache entry from localStorage.
 */
export function invalidateListCache(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    // Silently ignore
  }
}
